import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from "@angular/router";
import { AppSettings } from "../app.settings";
import { environment } from "../../environments/environment";
import { HttpResponse } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as CryptoJS from "crypto-js";
import { TokenValue } from "../models";
import { Observable, ReplaySubject } from "rxjs";
import { SessionDataService } from "./session-data.service";


@Injectable({
    providedIn: "root",
})
export class SharedService
{

    defaultTheme: string = "teal-light";
    isDark: boolean;
    tempPassword: string;
    customerID: string;
    isResetOrRegister: boolean;
    loginPageUrl: string;
    themeUrls: [".src/app/theme/styles/skins"]
    isPaymentForCODMade: boolean = false;

    isExternalLoginInstance = false;

    private dataLogicalSubject: ReplaySubject<string> = new ReplaySubject<string>(1);
    public dataLogical: Observable<string> = this.dataLogicalSubject.asObservable();

    // not sure if we can just...store this here or if it makes any dif to send it from webappapi...?
    private decryptionKey: string = "McQfTjWmZq4t7w!z"; // same key used in webappapi

    constructor(

        public activatedRoute: ActivatedRoute,
        public appSettings: AppSettings,
        public router: Router,
        public snackBar: MatSnackBar,
        private sessionDataService: SessionDataService
    )
    {
        this.setupLogical();
        this.getCustInfo();
        this.setDefaultTheme();
        this.getLoginPage();
    }

    public static IsNullOrEmpty(s: any): boolean
    {
        return (s == null || s === "");
    }

    public setupLogical(): void
    {
        this.router.events.subscribe(
            (event: RouterEvent) =>
            {
                if (event instanceof NavigationEnd)
                {
                    const dl = this.activatedRoute.snapshot.queryParamMap.get("logical");
                    if (dl)
                    {
                        this.dataLogicalSubject.next(dl);
                        this.sessionDataService.DataLogical = dl;
                    } 
                    else if (sessionStorage.getItem("userInfo"))
                    {
                        const userInfo: TokenValue = JSON.parse(sessionStorage.getItem("userInfo"));
                        this.dataLogicalSubject.next(userInfo.company_id + userInfo.logical);
                        this.sessionDataService.DataLogical = userInfo.company_id + userInfo.logical;
                    }
                }
            });
    }

    private getCustInfo(): void
    {
        try
        {
            this.activatedRoute.queryParamMap.subscribe(params =>
            {
                const tempPW = params.get("tpw");
                const custId = params.get("cid");

                if (!SharedService.IsNullOrEmpty(tempPW))
                {

                    const decodedTempPw = decodeURIComponent(tempPW);

                    this.tempPassword = this.decrypt(this.decryptionKey, decodedTempPw);

                    if (custId != null)
                    {
                        this.customerID = custId;
                    }
                }
                this.isResetOrRegister = this.customerID != null && this.tempPassword != null;
            });
        } catch (e)
        {
            console.log("Error. " + e);
        }
    }

    public getLoginPage(): void
    {
        this.loginPageUrl = window.location.href;
    }

    public redirect(): void
    {
        this.router.navigate(['/'], { queryParams: { logical: this.sessionDataService.DataLogical } });
    }

    decrypt(key: any, ciphertext: any): string
    {
        const parsedKey = CryptoJS.enc.Utf8.parse(key);
        const iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
        const decrypted = CryptoJS.AES.decrypt(ciphertext, parsedKey, { iv });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    public setDefaultTheme(theme: string = this.defaultTheme): void
    {
        if (this.appSettings.themes.includes(theme))
        {
            this.appSettings.settings.theme = theme;
        }
        else
        {
            this.appSettings.settings.theme = this.defaultTheme;
        }

        this.isDark = theme.includes("dark");
    }

    public GetServiceURL(path: string): string
    {
        return environment.baseServiceURL + path;
    }

    public extractData(res: Response)
    {
        const body = res.json();
        return body || {};
    }

    public extractHttpData(res: HttpResponse<any>): any
    {
        return res;
    }

}
